import React from 'react';
import { Button, Tooltip } from 'antd';
import { Moon, Sun } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/theme-context/ThemeContextProvider';

interface ThemeToggleProps {
  size?: 'small' | 'middle' | 'large';
  showTooltip?: boolean;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  size = 'middle',
  showTooltip = true
}) => {
  const { t } = useTranslation();
  const { isDark, toggleTheme } = useTheme();

  const iconSize = size === 'small' ? 16 : size === 'large' ? 24 : 20;

  const button = (
    <Button
      type="text"
      size={size}
      onClick={toggleTheme}
      icon={isDark ? <Sun size={iconSize} /> : <Moon size={iconSize} />}
      aria-label={isDark ? t('themeToggleLabels.switchToLightMode') : t('themeToggleLabels.switchToDarkMode')}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--color-text)',
      }}
    />
  );

  if (showTooltip) {
    return (
      <Tooltip title={isDark ? t('themeToggleLabels.lightMode') : t('themeToggleLabels.darkMode')}>
        {button}
      </Tooltip>
    );
  }

  return button;
};
